import Button from '../../../../../components/Button';
import GiftCard from '../../../../../components/GiftCard';
import { useGiftForm } from '../../../../../components/GiftFormContext';
import { useSelector } from 'react-redux';
import { selectTokenByNetworkAndAddress } from '../../../../../redux/slices/tokenSlice';
import TextInput from '../../../../../components/Inputs/Text';
import { hapticsImpactLight } from '../../../../../common/haptic';
import DeliveryMethods from './components/DeliveryMethods';
import { Controller } from 'react-hook-form';

const GiftFlowModal = ({ onContinue }) => {
  const {
    usdAmount,
    image,
    setValue,
    token,
    network,
    tokenAmount,
    delivery,
    control,
    errors,
  } = useGiftForm();

  const targetToken = useSelector((state) =>
    selectTokenByNetworkAndAddress(state, network, token),
  );

  const handleDeliveryMethodChange = (method) => {
    hapticsImpactLight();
    setValue('delivery', method);
  };

  const isValidForm =
    !errors.email?.message &&
    !errors.message?.message &&
    !errors.image?.message &&
    !errors.delivery?.message;

  return (
    <>
      <div style={{ width: '100%' }}>
        <GiftCard
          editable={true}
          hideValue
          usdAmount={usdAmount}
          tokenAmount={tokenAmount}
          cardImage={image}
          token={targetToken}
          onCardImageChange={(value) => setValue('image', value)}
        />
      </div>
      <DeliveryMethods
        handleDeliveryMethodChange={handleDeliveryMethodChange}
        delivery={delivery}
      />
      {delivery === 'email' && (
        <Controller
          name='email'
          control={control}
          render={({ field }) => (
            <TextInput
              label='Recipient Email'
              inputMode='email'
              type='email'
              placeholder='recipient@example.com'
              error={errors?.email?.message}
              {...field}
            />
          )}
        />
      )}
      <Controller
        name='message'
        control={control}
        render={({ field }) => (
          <TextInput
            label='Personal Message'
            inputMode='text'
            type='text'
            placeholder='Write a personal message'
            error={errors?.message?.message}
            {...field}
          />
        )}
      />
      <Button fullWidth onClick={onContinue} disabled={!isValidForm}>
        Continue
      </Button>
    </>
  );
};

export default GiftFlowModal;
